<template>
	<div id="InputAutoCompleteComponent">
        <input type="text" :placeholder="placeholder" v-model="query" @keyup="keyup($event)" @blur="enterBlur" autocomplete="off" :class="_class" :id="_id" :disabled="disabled"/>
        <div class="panel-footer divSearchData" v-if="searchData.length">
            <ul class="list-group">
                <a href="#" class="list-group-item" v-for="(item, ind) in searchData" @click="selectData(item)" :class="(ind == index) ? 'bg-info' : ''">
                    <i v-if="idem == ind">{{ item.text }}</i>
                    <span v-else>{{ item.text }}</span>
                </a>
            </ul>
        </div>
        <button v-show="1 == 0" ref="buttonClearInputComplete" @click="clearInputComplete"></button>
	</div>
</template>

<script>
    import mixin from '@/mixins'
    import errors from '@/mixins/errors.js'
    import axiosAction from '@/mixins/axiosAction.js'

    export default {
		name: 'InputAutoCompleteComponent',
        mixins: [mixin, errors, axiosAction],
        props: ['text', 'vmodel', '_id', '_class', 'placeholder', 'urlGet', 'disabled'],
		data () {
			return {
                query: '',
                queryAfter: '',
                searchData: [],
                index: -1,
                itemLocal: {
                    id: 0,
                    text: '',
                },
                item: {},
                click: false
			}
		},
		computed: {
            idem() {
                return this.searchData.map((el) => el.text.toLowerCase()).indexOf(this.query.toLowerCase())
            },
		},
		methods: {
            clearInputComplete() {
                this.index = -1
                this.query = this.queryAfter = this.text
                this.itemLocal.id = 0
                this.itemLocal.text = ''
                this.item = this.itemLocal
                this.searchData = []
                this.$emit('actionSelectItem', this.itemLocal, 'Enter')
            },
            keyup(event) {
                if(this.query != this.queryAfter) {
                    this.index = -1
                    this.queryAfter = this.query
                    this.itemLocal.id = 0
                    this.itemLocal.text = this.queryAfter
                    this.$emit('actionSelectItem', this.itemLocal, event.key)
                    if(this.query.length > 2) {
                        let param = "?search=" + this.query
                        this.axiosActionIS(this.apiBackend + this.urlGet + param, 'GET', 'getDataResult')
                    } else {
                        this.searchData = []
                    }
                } else {
                    if(event.key == 'ArrowDown' && this.searchData.length-1 > this.index) {
                        this.index++
                        this.query = this.queryAfter = this.searchData[this.index].text
                    } else if(event.key == 'ArrowUp' && this.index > 0){
                        this.index--
                        this.query = this.queryAfter = this.searchData[this.index].text
                    } else if (event.key == 'Enter' && this.query.length > 2) {
                        this.enterBlur()
                    }
                }
            },
            resultAxiosLocal(r, response) {
                this.searchData = []
                if(response.data.success) {
                    this.getDataResult(response)
                }
            },
            selectData(item) {
                this.click = true
                this.query = item.text
                this.itemLocal.id = item.id
                this.itemLocal.text = this.query
                this.searchData = []
                this.item = item
                this.$emit('actionSelectItem', this.item, 'Enter')
            },
            enterBlur() {
                setTimeout(() => {
                    if(!this.click){
                        if(this.index > -1) {
                            this.item = this.searchData[this.index]
                            this.$emit('actionSelectItem', this.item, 'Enter')
                        } else {
                            let index = this.searchData.map((el) => el.text.toLowerCase()).indexOf(this.query.toLowerCase())
                            if(index > -1) {
                                this.query = this.queryAfter = this.searchData[index].text
                                this.item = this.searchData[index]
                                this.$emit('actionSelectItem', this.item, 'Enter')
                            } else {
                                this.$emit('actionSelectItem', this.item, 'Enter')
                            }
                        }
                    }
                    this.click = false
                    this.index = -1
                    this.searchData = []
                }, 200)
            },
            getDataResult(response) {
                this.searchData = response.data.data
            }
		},
        mounted () {
	    	this.item = this.itemLocal
	    }
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.divSearchData {
    position: absolute;
    z-index: 1;
    width: auto;
    overflow: auto;
}
.divSearchData>ul {
    
}
.divSearchData>ul>a {
    padding: 2px 8px;
}

.divSearchData>ul>a:hover {
    background-color: #87ceeb;
}
</style>
